import React, { useEffect, useState } from "react";
import "./App.css";
import "./index.css";
import "./components/common-components/common-css/Common_Form_Css.css";
import "./components/common-components/common-css/Common_Css.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import All_products from "./components/all-products/All_products";
import My_Account from "./components/my_account/My_Account";
import Product_description from "./components/product-description/Product_description";
import Wishlist from "./components/wishlist/Wishlist";
import Cart from "./components/cart/Cart";
import Quick_quiz_stepform from "./components/quick-quiz-stepform/Quick_quiz_stepform";
import Login from "./components/login/Login";
import Reset_Password from "./components/login/reset_password/Reset_Password";
import Set_New_Password from "./components/login/set_new_password/Set_New_Password";
import Eyeq from "./components/eyeq/Eyeq";
import Contact_Us from "./components/contact_us/Contact_Us";
import Bapat_benifits from "./components/bapat-benifits/Bapat_benifits";
import Checkout from "./components/checkout/Checkout";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Refund_Policy from "./components/refund_policy/Refund_Policy";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import AppContext from "./utils/context";
import { useDispatch } from "react-redux";
import { checkTokenValidity } from "./features/auth/authSlice";
import Shipping_Policy from "./components/shipping_policy/Shipping_Policy";
import Order_details from "./components/my_orders/order_details/Order_details";
import Delivered_order from "./components/my_orders/delivered_order/Delivered_order";
import CryptoJS from "crypto-js";
import Login_Product_Detail from "./components/login/Login_Product_Detail";

const SECRET_KEY = "my_secret_key_123";

function App() {
  const dispatch = useDispatch();

  const checkToken = () => {
    dispatch(checkTokenValidity());
  };

  useEffect(() => {
    checkToken();
  }, [dispatch]);

  const location = useLocation();

  const hideLayoutRoutes = ["/login", "/reset-password", "/set-new-password"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [price, setPrice] = useState();

  const queryParams = new URLSearchParams(location.search);

  const token = queryParams.get("re");

  const [genderData, setGenderData] = useState(null);

  /*
   * ============================================================
   * INITIAL FILTER STATE
   * ============================================================
   */
  const [filters, setFilters] = useState({
    category: [],
    gender: [],
    material: [],
    frameType: [],
    colour: [],
    brands: [],
    frameShape: [],
    priceRange: "",
    sortBy: "",
    faceWidth: [],
    name: "",
  });

  /*
   * ============================================================
   * GENDER TOKEN
   * ============================================================
   */
  useEffect(() => {
    if (!token) return;

    try {
      const bytes = CryptoJS.AES.decrypt(token, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setFilters((prev) => ({
        ...prev,
        gender: [],
      }));

      handleFilterChange("gender", decryptedData);
    } catch (e) {
      console.error("Invalid token", e);
    }
  }, [token]);

  /*
   * ============================================================
   * CATEGORY TOKEN
   * ============================================================
   */
  const category = queryParams.get("category");

  useEffect(() => {
    if (!category) return;

    try {
      const bytes = CryptoJS.AES.decrypt(category, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setFilters((prev) => ({
        ...prev,
        category: [],
      }));

      handleFilterChange("category", decryptedData);
    } catch (e) {
      console.error("Invalid token", e);
    }
  }, [category]);

  /*
   * ============================================================
   * SHAPE TOKEN
   * ============================================================
   
   */
  const shapeToken = queryParams.get("shape");

  useEffect(() => {
    if (!shapeToken) return;

    try {
      const bytes = CryptoJS.AES.decrypt(shapeToken, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setFilters((prev) => ({
        ...prev,
        frameShape: [],
      }));

      handleFilterChange("frameShape", decryptedData);
    } catch (e) {
      console.error("Invalid token", e);
    }
  }, [shapeToken]);

  /*
   * ============================================================
   * BRAND TOKEN
   * ============================================================
  
   */
  const brandToken = queryParams.get("brands");

  useEffect(() => {
    if (!brandToken) return;

    try {
      const bytes = CryptoJS.AES.decrypt(brandToken, SECRET_KEY);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      setFilters((prev) => ({
        ...prev,
        brands: [],
      }));

      handleFilterChange("brands", decryptedData);
    } catch (e) {
      console.error("Invalid token", e);
    }
  }, [brandToken]);

  /*
   * ============================================================
   * RESET ALL FILTERS
   * ============================================================
   */
  const handleFilterReset = (filterName, value) => {
    setFilters({
      category: [],
      gender: [],
      material: [],
      frameType: [],
      colour: [],
      brands: [],
      frameShape: [],
      priceRange: "",
      sortBy: "",
      faceWidth: [],
      name: "",
    });
  };

  /*
   * ============================================================
   * NORMAL FILTER CHANGE
   * ============================================================
   *
   * Used by the normal Product_filter component.
   *
   * This remains a toggle system because the sidebar filters
   * can have multiple selected values.
   */
  const handleFilterChange = (filterName, value) => {
    if (value === null) {
      setFilters((prev) => ({
        ...prev,
        [filterName]: null,
      }));
      return;
    }

    setFilters((prevFilters) => {
      if (Array.isArray(prevFilters[filterName])) {
        const currentValues = [...prevFilters[filterName]];

        const existingItemIndex = currentValues.findIndex(
          (item) => item.id === value.id,
        );

        if (existingItemIndex !== -1) {
          return {
            ...prevFilters,
            [filterName]: currentValues.filter((item) => item.id !== value.id),
          };
        } else {
          return {
            ...prevFilters,
            [filterName]: [...currentValues, value],
          };
        }
      } else {
        return {
          ...prevFilters,
          [filterName]: value,
        };
      }
    });
  };

  /*
   * ============================================================
   * MEGA MENU FILTER CHANGE
   * ============================================================
   
   */
  const handleMegaFilterChange = (
    primaryType,
    primaryValue,
    secondaryType,
    secondaryValue,
  ) => {
    let updatedFilters = {
      category: [],
      gender: [],
      material: [],
      frameType: [],
      colour: [],
      brands: [],
      frameShape: [],
      priceRange: "",
      sortBy: "",
      faceWidth: [],
      name: "",
    };

    /*
      Example:

      Sunglasses + Men

      primaryType = category
      primaryValue = Sunglasses
      secondaryType = gender
      secondaryValue = Men
    */

    if (primaryType && primaryValue) {
      updatedFilters[primaryType] = [primaryValue];
    }

    if (secondaryType && secondaryValue) {
      updatedFilters[secondaryType] = [secondaryValue];
    }

    setFilters(updatedFilters);
  };

  /*
   * ============================================================
   * SINGLE CATEGORY FILTER (Meta AI)
   * ============================================================
   
   */
  const handleSingleCategoryFilter = (categoryObj) => {
    setFilters({
      category: categoryObj ? [categoryObj] : [],
      gender: [],
      material: [],
      frameType: [],
      colour: [],
      brands: [],
      frameShape: [],
      priceRange: "",
      sortBy: "",
      faceWidth: [],
      name: "",
    });
  };

  /*
   * ============================================================
   * SEARCH CATEGORY SELECT
   * ============================================================
   *
   * Used by the search bar's category dropdown.
   *
   
   */
  const handleSearchCategorySelect = (categoryObj) => {
    setFilters((prev) => ({
      ...prev,
      category: categoryObj ? [categoryObj] : [],
    }));
  };

  return (
    <>
      <AppContext>
        <ScrollToTop />

        {!hideLayout && (
          <Header
            filters={filters}
            handleFilterChange={handleFilterChange}
            handleMegaFilterChange={handleMegaFilterChange}
            handleSingleCategoryFilter={handleSingleCategoryFilter}
          />
        )}

        <Routes>
          <Route
            path="/"
            element={<Home handleFilterChange={handleFilterChange} />}
          />

          <Route path="/login" element={<Login />} />

          <Route
            path="/login-product-detail"
            element={<Login_Product_Detail />}
          />

          <Route
            path="/reset-password"
            element={
              <Reset_Password
                email={email}
                setEmail={setEmail}
                contact={contact}
                setContact={setContact}
              />
            }
          />

          <Route
            path="/set-new-password"
            element={
              <Set_New_Password
                email={email}
                setEmail={setEmail}
                contact={contact}
                setContact={setContact}
              />
            }
          />

          <Route
            path="/all-products"
            element={
              <All_products
                filters={filters}
                handleFilterChange={handleFilterChange}
                handleSearchCategorySelect={handleSearchCategorySelect}
                price={price}
                setPrice={setPrice}
                handleFilterReset={handleFilterReset}
              />
            }
          />

          <Route path="/my-account" element={<My_Account />} />

          <Route path="/order-details/:id" element={<Order_details />} />

          <Route path="/delivered-order" element={<Delivered_order />} />

          <Route
            path="/product-descrption/:id"
            element={<Product_description />}
          />

          <Route path="/wishlist" element={<Wishlist />} />

          <Route path="/cart" element={<Cart />} />

          <Route
            path="/quick-quiz"
            element={
              <Quick_quiz_stepform
                onFilterChange={handleFilterChange}
                filters={filters}
                handleFilterReset={handleFilterReset}
              />
            }
          />

          <Route path="/eye-q" element={<Eyeq />} />

          <Route path="/contact-us" element={<Contact_Us />} />

          <Route path="/bapat-benefits" element={<Bapat_benifits />} />

          <Route path="/proceed-to-Checkout" element={<Checkout />} />

          <Route path="/shipping-policy" element={<Shipping_Policy />} />

          <Route path="/terms-conditions" element={<Terms_Conditions />} />

          <Route path="/refund-policy" element={<Refund_Policy />} />

          <Route path="/privacy" element={<Privacy_Policy />} />
        </Routes>

        {!hideLayout && <Footer handleFilterChange={handleFilterChange} />}
      </AppContext>
    </>
  );
}

export default App;
